module.exports = __webpack_public_path__ + "static/media/account_circle-24px-outline.4bf9b326.svg";